import { proxy } from "valtio";
import { Contract } from "@models/contract.model";
import { Budget } from "@models/budget.model";
import { Pricesheet } from "@models/pricesheet.model";
import { PricesheetItem } from "@models/pricesheetitem.model";
import { SpendAccount } from "@models/spendaccount.model";
import { Credit } from "@models/credit.model";
import { Debit } from "@models/debit.model";

interface OrganizationContractsState {
  organizationId: number | null;
  contracts: Contract[];
  selectedContractId: number | null;
  budgets: Budget[];
  pricesheets: Pricesheet[];
  pricesheetItems: PricesheetItem[];
  spendAccount: SpendAccount | null;
  credits: Credit[];
  debits: Debit[];
  balance: number | null;
  isLoading: boolean;
  isSaving: boolean;
  error: string | null;
}

export const organizationContractsStore = proxy<OrganizationContractsState>({
  organizationId: null,
  contracts: [],
  selectedContractId: null,
  budgets: [],
  pricesheets: [],
  pricesheetItems: [],
  spendAccount: null,
  credits: [],
  debits: [],
  balance: null,
  isLoading: false,
  isSaving: false,
  error: null,
});

export function resetOrganizationContractsStore() {
  organizationContractsStore.organizationId = null;
  organizationContractsStore.contracts = [];
  organizationContractsStore.selectedContractId = null;
  organizationContractsStore.budgets = [];
  organizationContractsStore.pricesheets = [];
  organizationContractsStore.pricesheetItems = [];
  organizationContractsStore.spendAccount = null;
  organizationContractsStore.credits = [];
  organizationContractsStore.debits = [];
  organizationContractsStore.balance = null;
  organizationContractsStore.isLoading = false;
  organizationContractsStore.isSaving = false;
  organizationContractsStore.error = null;
}
